import React from 'react';
import { CtaButton } from './CtaButton';
import { Reassurance } from './Reassurance';
import { HERO_IMAGE } from '../data/content';
export function Hero() {
  return <section className="w-full bg-white px-4 pb-10 pt-10 sm:px-6 sm:pt-14" data-id="element-64" data-mp="ei1vtn9me4yh">
      <div className="mx-auto max-w-4xl text-center" data-id="element-65" data-mp="9l32h6xs621c">
        <h1 className="font-display text-3xl font-extrabold leading-[1.1] tracking-tight text-brand-deep sm:text-5xl lg:text-[3.4rem]" data-id="element-66" data-mp="4mi2n8mfxkdf">
          Cómo Reiniciar tu Metabolismo y Desinflamar tu Abdomen{' '}
          <span className="text-brand" data-id="element-67" data-mp="xa4ef45tnvbd">en solo 9 días</span>… Sin Dietas
          Extremas ni Horas de Cardio
        </h1>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-gray-600 sm:text-lg" data-id="element-68" data-mp="s9q75oc1opee">
          Un protocolo educativo en 6 tomos diseñado para ayudarte a identificar
          los hábitos que pueden estar saboteando tu metabolismo, mejorar tus
          comidas y recuperar una sensación de ligereza desde la raíz.
        </p>

        <div className="mt-8" data-id="element-69" data-mp="3j8ixz1o3okvr">
          <img src={HERO_IMAGE} alt="Los 6 tomos de la Enciclopedia del Reinicio Metabólico junto a la app en tablet y móvil" className="mx-auto w-full max-w-3xl" width={1536} height={1024} data-id="element-70" data-mp="3j897lcz58bpj" />
        </div>

        <div className="mx-auto mt-8 max-w-md" data-id="element-71" data-mp="3e95ztkrs3rdv">
          <CtaButton href="#precio" location="hero" data-id="element-72" data-mp="3e7uvnjuf8hm8">
            Quiero mi acceso hoy
          </CtaButton>
          <Reassurance className="mt-3" items={['Acceso inmediato', '100% digital', 'Un solo pago', 'Sin suscripciones']} data-id="element-73" data-mp="30gq47517ivmz" />
        </div>
      </div>
    </section>;
}